import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getOpname(params) {
	return client.get("api/product-stock/data-opname", {
		params: params,
	});
}

function getOpnameAll(params) {
	return client.get("api/product-stock/data-opname-all", {
		params: params,
	});
}

function getDetailOpname(params) {
	return client.get("api/product-stock/detail-opname", {
		params: {
			code : params
		},
	});
}

function exportOpname(params) {
	return client.get("api/product-stock/export-stock-opname", {
		params: params,
	});
}

function exportOpnameAll(params) {
	return client.get("api/product-stock/export-stock-opname-all", {
		params: params,
	});
}

function exportTemplateOpname(params) {
	return client.get("api/product-stock/export-template-stock-opname", {
		params: params,
	});
}

function importOpname(params) {
	return client.post("api/product-stock/import-stock-opname", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

function createOpname (params) {
	return client.post("api/product-stock/stock-opname", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function approvalOpname (params) {
	return client.post("api/product-stock/update-stock-opname", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getOpname,
	getOpnameAll,
	getDetailOpname,
	exportOpname,
	exportOpnameAll,
	exportTemplateOpname,
	importOpname,
	createOpname,
  approvalOpname,
};
